<template>
  <div class="xelement">
    <xlogin v-if="!isLogin" :title="title" :url="url.login" @loginSuccess="loginSuccess"></xlogin>
    <div class="header" v-if="isLogin">
      <div class="logo">
        <img src="../assets/logo.png">
        <h2>{{title}}</h2>
      </div>
      <div class="tools">
        <a href="javascript:;" class="item" @click="logout">
          <el-tooltip content="登出" placement="bottom"><i class="el-icon-x-logout"></i></el-tooltip>
        </a>
        <router-link :to="tool.path" class="item" v-for="tool in tools">
          <el-tooltip :content="tool.title" placement="bottom"><i :class="'el-icon-' + tool.icon"></i></el-tooltip>
        </router-link>
      </div>
    </div>
    <div class="main" v-if="isLogin">
      <div class="menu">
        <div class="userinfo">
          <div class="name">{{userinfo.name}}</div>
          <div class="it"><span class="tit">余额：</span>¥{{userinfo.balance}}</div>
        </div>
        <el-menu :default-active="defaultActive" theme="dark" :router="true" :unique-opened="true">
          <template v-for="(item, index) in menu">
            <el-submenu v-if="item.sub != undefined" :index="'index-' + index">
              <template slot="title"><i :class="'el-icon-' + item.icon"></i>{{item.title}}</template>
              <template v-for="it in item.sub">
                <el-menu-item-group v-if="it.sub != undefined" :title="it.title">
                  <el-menu-item v-for="submenu in it.sub" :index="submenu.index">{{submenu.title}}</el-menu-item>
                </el-menu-item-group>
                <el-menu-item v-if="it.sub == undefined" :index="it.index">{{it.title}}</el-menu-item>
              </template>
            </el-submenu>
            <el-menu-item v-if="item.sub == undefined" :index="item.index"><i :class="'el-icon-' + item.icon"></i>{{item.title}}</el-menu-item>
          </template>
        </el-menu>
      </div>
      <div class="content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import ajax from './ajax'
import Xlogin from './login.vue'

export default {
  name: 'xmain',
  props: ['title', 'url', 'menu', 'tools'],
  data() {
    return {
      userinfo: {
        name: '',
        balance: 0
      },
      isLogin: false,
      defaultActive: this.$route.path
    }
  },
  created(){
    this.verifyLogin();
  },
  methods: {
    logout(){
      let _self = this;
      this.$confirm('是否确认登出系统', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ajax(_self, 'get', _self.url.logout, {}, (res) => {
          _self.isLogin = false;
        })
      }).catch(() => {
                 
      });
    },
    loginSuccess(){
      this.isLogin = true;
      this.getUserData();
    },
    verifyLogin(){
      let _self = this;
      ajax(this, 'post', this.url.verify, {}, (res) => {
        _self.isLogin = true;
        _self.getUserData();
      })
    },
    getUserData(){
      let _self = this;
      ajax(this, 'get', this.url.userData, {}, (res) => {
        _self.userinfo.name = res.data.name;
        _self.userinfo.balance = res.data.balance;
      })
    }
  },
  components:{
    Xlogin
  }
}
</script>


// WEBPACK FOOTER //
// main.vue?1ef1bbb9